import {
  Button,
  IconButton,
  TextField,
  Typography,
  makeStyles
} from "@material-ui/core";
import { useDynamicList, useUpdateEffect } from "ahooks";
import { IconTrash } from "@/components/Icon";
import { useTranslation } from "@/langs/useTranslation";
import SingleSelector from "@/components/SingleSelector";
import { FormItem } from "@/components/Form";

const useStyles = makeStyles(theme => ({
  root: {
    background: "#F8F9FC",
    borderRadius: 10,
    padding: theme.spacing(3)
  },
  body: {
    borderRadius: 4,
    overflow: "hidden"
  },
  item: {
    display: "flex",
    alignItems: "center",
    padding: `${theme.spacing(0.5)}px 0`,

    "& > div:not(:last-child)": {
      flex: 1,
      marginRight: theme.spacing(3)
    }
  }
}));

export const useRuleList = () => {
  const { t } = useTranslation();
  const options = [
    {
      id: 1,
      name: t({ defaultMessage: "自定义文字" })
    },
    {
      id: 2,
      name: t({ defaultMessage: "自然数递增" })
    },
    {
      id: 3,
      name: "Mac Address"
    },
    {
      id: 4,
      name: "Model"
    },
    {
      id: 5,
      name: t({ defaultMessage: "个人设备名称" })
    },
    {
      id: 6,
      name: t({ defaultMessage: "设备序列号" })
    }
    // {
    //   id: 7,
    //   name: t({ defaultMessage: "门店名称" })
    // },
    // {
    //   id: 8,
    //   name: t({ defaultMessage: "公司名称" })
    // }
  ];
  return options;
};

const RuleSelector = ({ disabled, name, value, onChange }) => {
  const options = useRuleList();

  return (
    <SingleSelector
      options={options}
      disabled={disabled}
      clearable={false}
      name={name}
      value={value}
      onChange={onChange}
      style={{ width: "100%" }}
    />
  );
};

const Item = ({ index, disabled, item, remove, replace }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const textInput = (
    <TextField
      variant="outlined"
      size="small"
      fullWidth
      placeholder={t({ defaultMessage: "请输入" })}
      disabled={disabled}
      value={item.value}
      onChange={e => replace(index, { ...item, value: e.target.value })}
    />
  );

  return (
    <div className={classes.item}>
      <div>
        <RuleSelector
          disabled={disabled}
          value={item.type}
          onChange={e => replace(index, { ...item, type: e.target.value })}
        />
      </div>
      <div>
        {item.type === 1 ? (
          textInput
        ) : item.type === 2 ? (
          <FormItem
            label={t({ defaultMessage: "起始号码" })}
            style={{ marginBottom: 0 }}
          >
            {textInput}
          </FormItem>
        ) : null}
      </div>
      <div>
        {!disabled && (
          <IconButton style={{ float: "right" }} onClick={() => remove(index)}>
            <IconTrash color="secondary" size={14} />
          </IconButton>
        )}
      </div>
    </div>
  );
};

const NamingCreator = ({ disabled, name, value = [], onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { list, getKey, insert, remove, replace } = useDynamicList(value);

  const handleInsert = () => {
    insert(list.length, { type: 1, value: undefined });
  };

  useUpdateEffect(() => {
    onChange?.({ target: { name, value: list } });
  }, [list]);

  return (
    <div className={classes.root}>
      <Typography
        variant="subtitle1"
        style={{ marginBottom: 18, fontWeight: "bold" }}
      >
        {t({ defaultMessage: "配置规则" })}
      </Typography>
      <div className={classes.body}>
        {list.map((item, index) => (
          <Item
            key={getKey(index)}
            disabled={disabled}
            index={index}
            item={item}
            remove={remove}
            replace={replace}
          />
        ))}
      </div>
      {!disabled && (
        <Button
          color="primary"
          variant="outlined"
          disabled={disabled}
          onClick={handleInsert}
          style={{ marginTop: 16, minWidth: 118 }}
        >
          {t({ defaultMessage: "新增规则" })}
        </Button>
      )}
    </div>
  );
};

export default NamingCreator;
